import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Notification from 'rc-notification';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import MonthStats from './MonthStats';
import MonthlyLineChart from './MonthlyLineChart';
import ShowMonthDayCategoryWise from './ShowMonthDayCategoryWise';
import { getCompareMonthData, handleLoader } from '../../../redux/actions/CompareMonthAction';
import { getCompareMonthAllData, handleAllLoader } from '../../../redux/actions/compareMonthsAllAction';
import { months, monthWithDays, filterShowWise, vendorNameMapping } from '../helper';

const CompareMonth = ({ dispatch, rtl, vendor }) => {
  const currentYear = moment().format('YYYY');
  const prevYear = currentYear - 1;
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(1, 'months').format('MMM');

  const { compareMonthSalesData, compareMonthSalesAllData,
     salesChannelFilterData, isLoading, isAllLoading } = useSelector(
    ({ compareMonthSalesReducer, compareMonthAllReducer, marketPlaceReducer }) =>
    ({
      compareMonthSalesData: compareMonthSalesReducer?.[vendor]?.compareMonthSalesData,
      isLoading: compareMonthSalesReducer?.[vendor]?.isLoading,
      compareMonthSalesAllData: compareMonthAllReducer?.[vendor]?.compareMonthSalesAllData,
      isAllLoading: compareMonthAllReducer?.[vendor]?.isAllLoading,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      
    })
  );

  const [dataToShow, setDataToShow] = useState(compareMonthSalesData?.modal?.data?.[0]?.yearlySales);
  const [dataToShowAll, setDataToShowAll] = useState(compareMonthSalesAllData?.modal?.data?.[0]?.yearlySales);
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0]);
  const [filterData, setFilterData] = useState({});
  const [month1, setMonth1] = useState({ year: currentYear, month: currentMonth });
  const [month2, setMonth2] = useState({ year: prevYear, month: prevMonth })

  const month1Days = monthWithDays[month1?.month];
  const month2Days = monthWithDays[month2?.month];

  const monthDays = month2Days > month1Days ? month2Days : month1Days;

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const currentMonthData = dataToShow?.[month1.year]?.monthlySales?.[month1?.month] ?? []
  const prevMonthData = dataToShow?.[month2.year]?.monthlySales?.[month2?.month] ?? []
  const prevYearMonthData = dataToShow?.[month1.year - 1]?.monthlySales?.[month1?.month] ?? [];

  // data for all //
  const currentMonthDataAll = dataToShowAll?.[month1.year]?.monthlySales?.[month1?.month] ?? []
  const prevMonthDataAll = dataToShowAll?.[month2.year]?.monthlySales?.[month2?.month] ?? []
  const prevYearMonthDataAll = dataToShowAll?.[month1.year - 1]?.monthlySales?.[month1?.month] ?? [];

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setMonth2({ ...month2, [field]: value?.value })
      if (field === 'year') {
        dispatch(handleLoader(true, vendor));
        dispatch(getCompareMonthData({ from: month1.year, to: value?.value, vendor }));
        dispatch(handleAllLoader(true, vendor));
        dispatch(getCompareMonthAllData({ from: month1.year, to: value?.value, vendor }));
      }
    } else {
      setMonth1({ ...month1, [field]: value?.value });
      if (field === 'year') {
        dispatch(handleLoader(true, vendor));
        dispatch(getCompareMonthData({ from: value?.value, to: month1.year, vendor }));
        dispatch(handleAllLoader(true, vendor));
        dispatch(getCompareMonthAllData({ from: value?.value, to: month1.year, vendor }));
      }      
    }
  }

  // implement PDF generateor //
  const container = React.useRef(null)
  const exportToPDF = () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
     const dvChartV = document.getElementById('dvChartView');
     dvChartV.style.display = "none";    
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 5,
      fileName: `Compare Sales by Month Report ${new Date().getFullYear()}`,
    })
     dvChartV.style.display = "block"; 
  }

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="4">
      <Card className="pb-3">
        <CardBody className="min-w-50 p-3">
          <Row className="justify-content-space-between">
            <Col sm="6">
              <div className="form__form-group mb-0">
                <span className="form__form-group-label">{isFrom ? 'Previous' : 'Current'} Year</span>
                <div className="form__form-group-field">
                  <Select
                    value={isFrom ? { value: month2?.year, label: month2?.year }
                      : { value: month1?.year, label: month1?.year }}
                    options={yearOptions}
                    clearable={false}
                    placeholder="Select Year"
                    className="select_filter-110"
                    onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                    classNamePrefix="react-select"
                    name={isFrom ? 'from' : 'to'}
                  />
                </div>

              </div>
            </Col>
            <Col sm="6">
              <div className="form__form-group mb-0">
                <span className="form__form-group-label">Month</span>
                <div className="form__form-group-field">
                  <Select
                    value={isFrom ? { value: month2?.month, label: month2?.month }
                      : { value: month1?.month, label: month1?.month }}
                    options={monthOptions}
                    clearable={false}
                    placeholder="Select Month"
                    className="select_filter-110"
                    onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                    classNamePrefix="react-select"
                    name={isFrom ? 'fromMonth' : 'toMonth'}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );

  useEffect(() => {
    dispatch(handleLoader(true, vendor));
    dispatch(getCompareMonthData({ from: currentYear, to: prevYear, vendor }));
    dispatch(handleAllLoader(true, vendor));
    dispatch(getCompareMonthAllData({ from: currentYear, to: prevYear, vendor }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(compareMonthSalesData?.modal?.data?.[0]?.yearlySales);
  }, [compareMonthSalesData]);

  useEffect(() => {
    setDataToShowAll(compareMonthSalesAllData?.modal?.data?.[0]?.yearlySales);
  }, [compareMonthSalesAllData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  const filteredCurrentMonthData =
    currentMonthData?.filter(item => filterBasedOnFilter({ ...item, productCategory: item.category }));
  const filteredPrevMonthData =
    prevMonthData?.filter(item => filterBasedOnFilter({ ...item, productCategory: item.category }));

    const prevYearMonthDayWise = {};
  const currentYearMonthDayWise = {};
  const currentYearPrevMonthDayWise = {};
    // Data for All //
     const filteredCurrentMonthDataAll =
     currentMonthDataAll?.filter(item => filterBasedOnFilter({ ...item, productCategory: item.category }));
   const filteredPrevMonthDataAll =
     prevMonthDataAll?.filter(item => filterBasedOnFilter({ ...item, productCategory: item.category }));

  

  for (let i = 0; i <= prevYearMonthData.length; i += 1) {
    const dayData = prevYearMonthData[i];
    if (dayData)
      dayData.productCategory = dayData?.category;
    if (dayData?.day && filterBasedOnFilter(dayData)) {
      if (prevYearMonthDayWise[dayData?.day]) {
        prevYearMonthDayWise[dayData?.day]?.push(dayData)
      } else if (dayData) {
        prevYearMonthDayWise[dayData?.day] = [dayData]
      }
    }

  }

  for (let i = 0; i <= prevMonthData.length; i += 1) {
    const dayData = prevMonthData[i]
    if (dayData?.day && filterBasedOnFilter(dayData)) {
      if (dayData?.day && currentYearPrevMonthDayWise[dayData.day]) {
        currentYearPrevMonthDayWise[dayData?.day]?.push(dayData)
      } else if (dayData) {
        currentYearPrevMonthDayWise[dayData?.day] = [dayData]
      }
    }
  }

  for (let i = 0; i <= currentMonthData.length; i += 1) {
    const dayData = currentMonthData[i]
    if (dayData?.day && filterBasedOnFilter(dayData)) {
      if (dayData?.day && currentYearMonthDayWise[dayData?.day]) {
        currentYearMonthDayWise[dayData?.day]?.push(dayData)
      } else if (dayData) {
        currentYearMonthDayWise[dayData?.day] = [dayData]
      }
    }
  }

  return (
    <Container className="dashboard">
      <div className="compare-months">
        <Card className="pb-3">
          <CardBody className="min-w-50 p-3">
            <div className="card__title mb-2">
              <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} Compare Sales By Month </h5>
            </div>
            <Row className="justify-content-space-between">
              <Col sm="2" className="pr-0">
                <div className="form__form-group mb-0">
                  <span className="form__form-group-label">Show</span>
                  <div className="form__form-group-field">
                    <Select
                      value={currentlyShow}
                      options={filterShowWise}
                      clearable={false}
                      placeholder="Select "
                      className="select_filter"
                      onChange={value => changeFilter(value)}
                      classNamePrefix="react-select"
                    />
                  </div>

                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <div className="internal-filter">
          <Row className="justify-content-right align-items-center ">
            <RenderYearAndMonth isFrom />
            <Col sm='1' className="filter-to-position text-center">~</Col>
            <RenderYearAndMonth />
            <Col md="3">
                <button className="btn btn-sm btn-primary apply-date-button" 
                type="button"
                                    onClick={exportToPDF} title='Export to pdf'
                                    disabled={isLoading}>Export pdf</button></Col>
          </Row>
        </div>
      </div>      
      <div ref={container}>
      <Row >
      <Col xs={12}>
          <Card>
            <CardBody>
              <MonthStats
                monthData={filteredPrevMonthData}
                monthDataAll={filteredPrevMonthDataAll}
                month={month2}
                filterBasedOnFilter={filterBasedOnFilter}
                isPrevious
                isLoading={isAllLoading} />
            </CardBody>
          </Card>
        </Col>
        <Col xs={12}>
          <Card>
            <CardBody>
              <MonthStats monthData={filteredCurrentMonthData} 
              monthDataAll={filteredCurrentMonthDataAll} 
              month={month1} filterBasedOnFilter={filterBasedOnFilter}
                isLoading={isAllLoading} />
            </CardBody>
          </Card>
        </Col>        
      </Row>
      <Row>
        <Col xs={12}>
          <Card>
            <CardBody>
              {isLoading ? (<>
                <div className="card__title">
                  <h5 className="bold-text">Compare Monthly Sales</h5>
                </div>
                <div
                  style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center"
                >
                  <SmallLoader loading={isLoading} />
                </div>
              </>
              ) : (
                <MonthlyLineChart
                  dir={rtl.direction}
                  monthDays={monthDays}
                  currentYearPrevMonthDayWise={currentYearPrevMonthDayWise}
                  currentYearMonthDayWise={currentYearMonthDayWise}
                  prevYearMonthDayWise={prevYearMonthDayWise}
                  height={400}
                  month1={month1}
                  month2={month2}
                  showLastYear
                />)}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <ShowMonthDayCategoryWise
          dir={rtl.direction}
          currentMonthData={filteredCurrentMonthData}
          prevMonthData={filteredPrevMonthData}
          height={400}
          showLastYear={false}
          monthDays={monthDays}
          filterData={filterData}
          month1={month1}
          month2={month2}
          title={`Monthly Sales Comparison By ${currentlyShow?.label}`}
          categorisedBasedOn={currentlyShow?.value}
          currentlyShow={currentlyShow}
          isLoading={isLoading}
        />
      </Row>
      </div>
    </Container>
  );
};

CompareMonth.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
};

export default connect(state => ({
  rtl: state.rtl,
}))(CompareMonth);
